import { render, staticRenderFns } from "./D2PLOD0090.vue?vue&type=template&id=6a06b2d3&scoped=true&"
import script from "./D2PLOD0090.js?vue&type=script&lang=js&"
export * from "./D2PLOD0090.js?vue&type=script&lang=js&"
import style0 from "./D2PLOD0090.vue?vue&type=style&index=0&id=6a06b2d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a06b2d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VIcon,VRow})
